import { Suspense } from "react";

import ProductDetail from "../features/detail/ProductDetail";

export default function ProductNew() {
    return (
        <Suspense fallback={ <div>loading</div> }>
            <ProductDetail />
        </Suspense>
    );
}
